import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import apiClient from '../api/apiClient';

// Creating a Context for Location
const LocationContext = React.createContext();

// Custom hook to consume LocationContext
export const useGetLocation = () => useContext(LocationContext);

// Location Provider Component
export const LocationSendProvider = ({ children }) => {
  const [locationData, setLocationData] = useState({});
  const [location, setLocation] = useState([]);
  const [socket, setSocket] = useState(null);
  const [campaign_id, setcampaign_id] = useState(null);
  const [vehicle_id, setvehicle_id] = useState(null);
  const [tracking,settracking]=useState(false)

  const [preLocation, setpreLocation] = useState({});
  

  // const tracking = useSelector((state) => state.auth.tracking);

  // const fetchsavelocation= async()=>{  

  //   const response =  await apiClient.get(`/campaign/tracking/?vehicle_id=${vehicle_id}`);

  // }
  // console.log(vehicle_id);
  
  //  useEffect(()=>{
  //   fetchsavelocation()
  //  },[campaign_id])

 



  // Save campaign_id to localStorage whenever it changes
  
    // useEffect(() => {
    //   if(campaign_id){
    //   localStorage.setItem('campaign_id', campaign_id);
    // }}, [campaign_id]);
    // useEffect(() => {
    //   const storedCampaignId = localStorage.getItem('campaign_id');
    //   if (storedCampaignId) {
    //     setcampaign_id(storedCampaignId);
    //   }
    // }, []);
  

  useEffect(() => {
    const location_send_ws = new WebSocket(`wss://priority-app-api-b3be191b4e64.herokuapp.com/realtime-tracking/2/`);
  
    location_send_ws.addEventListener('open', (event) => {
      console.log('Send WebSocket connection opened:', event);
    });
  
    location_send_ws.addEventListener('message', (event) => {
      console.log('Message from server:', event.data);
      const data = JSON.parse(event.data);
  


      
    });
  
  
    location_send_ws.addEventListener('close', (event) => {
      console.log('WebSocket connection closed:', event);
    });
  
    location_send_ws.addEventListener('error', (error) => {
      console.error('WebSocket error:', error);
    });
    
    setSocket(location_send_ws);
  
    return () => {
      location_send_ws.close();
    };
  }, []);
 
  
  useEffect(() => {
    const fetchLocation = () => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // toast.info(JSON.stringify({latitude,longitude}))
          console.log(latitude,longitude,'longitude');
          const newLocation = { latitude:Math.random(), longitude,  vehicle: vehicle_id, "campaign": campaign_id, "bitrix_id": 2021 };
         
      
          // Check if latitude or longitude has changed


      
          
      
          setLocationData(prevLocationData => {
            // Check if latitude or longitude has changed
            if (
              Object.keys(prevLocationData).length === 0 ||
              prevLocationData.latitude !== newLocation.latitude ||
              prevLocationData.longitude !== newLocation.longitude
            ) {
              return newLocation;
            } else {
              return prevLocationData; 
              // Return unchanged state if no update is needed
            }
          });
        
                 },
        (error) => {
          console.error('Error getting location:', error.message);
        },
        {
          enableHighAccuracy: false,
          timeout: 1000,
          maximumAge: 0,
        }
      );
    }; 
    // setLocation(data);
   

 

    
    if (tracking) {
      const intervalId = setInterval(fetchLocation, 5000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [tracking, socket, location]);
  const sendToWebSocket = (data) => {
    console.log(locationData,"locationData");
        // const response =  apiClient.post(`/campaign/tracking/`, data); 

    if (tracking && socket) {
socket.send(JSON.stringify(data));




}
  };
  useEffect(()=>{
    if(Object.keys(locationData).length>0){
      sendToWebSocket(locationData)
      console.log("reintialized");
    }
        },[locationData])

  const value = {
    location,
    setLocation,
    setcampaign_id,
    locationData,
    setvehicle_id,
    settracking
  };



  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};
